<script lang="ts">
	interface Props {
		name: string
		center?: boolean
	}

	let { name, center = false }: Props = $props()

	let middle = $derived(Math.ceil(name.length / 2))
	let nameFirst = $derived(name.substring(0, middle))
	let nameSecond = $derived(name.substring(middle))
</script>

<div
	class="text-primary-500 flex h-[42px] items-center truncate text-4xl font-bold uppercase {center
		? 'm-auto justify-center text-center'
		: ''}"
>
	<div class="inline-flex truncate">
		{nameFirst}
		<div class="bg-primary-500 px-2 text-white">
			{nameSecond}
		</div>
	</div>
</div>
